<template>
  <div class="c-remove">
    <img class="c-remove__img" src="@/assets/myMusic/icon_remove.svg" @click="handleApi">
  </div>
</template>
<script>
import { defineComponent, watch, inject } from 'vue';
// import { useRoute } from 'vue-router';
import { useMessage } from 'naive-ui';
import { useI18n } from 'vue-i18n';
import useRequest from '@/hooks/useRequest';
import { removeAccountPlaylistContentAPI } from '@/api/myMusicPlaylists';
import usePopInfo from '@/hooks/usePopInfo';
// import { firstLetterUpperCase } from '@/utils/firstLetterUpperCase';

export default defineComponent({
  name: 'Remove',
  props: {
    type: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { t } = useI18n();
    const { successPopInfo } = usePopInfo();
    const message = useMessage();
    const reloadPlaylistContent = inject('reloadPlaylistContent');
    // const route = useRoute();

    const {
      request: removeAccountPlaylistContentRequest,
      response: removeAccountPlaylistContentResponse } = useRequest(removeAccountPlaylistContentAPI);

    const removeAccountPlaylistContent = async () => {
      await removeAccountPlaylistContentRequest({
        in: {
          accountPlaylistContentUid: props.data.accountPlaylistContentUid,
          accountPlaylistUid: props.data.accountPlaylistUid,
          // title: props.data.album.albumTitleDisplay, // 顯示在活動紀錄上
        },
      });

      await reloadPlaylistContent();
    };

    const handleApi = async () => {
      successPopInfo({
        desc: t('msg.removeConfirm'),
        callback: removeAccountPlaylistContent,
        showClose: true,

      });
    };

    watch(removeAccountPlaylistContentResponse, () => {
      const [err, res] = removeAccountPlaylistContentResponse.value;

      if (err) {
        // message.error(err.message);
        return;
      }

      if (res) {
        message.success(t('msg.removeSuccess'));
      }
    });

    return {
      handleApi,

    };
  },
});
</script>
<style lang="scss" scoped>
.c-remove {
  width: 100%;
  @include flex(center);
}
</style>
